<template>
	<div ref="floatRef" class="float-btn" :style="style">
		<div class="float-wrap" @click.prevent="handleClick" v-if="num">
			<div class="float-icon">
				<xl-icon :size="28" color="#5587FF"><PrinterList></PrinterList></xl-icon>
			</div>
			<div class="num">{{ num }}</div>
		</div>
	</div>
</template>

<script setup>
import { XlIcon } from "@shining3d/ui-components";
import { PrinterList } from '@shining3d/icons-vue'; 

import { computed, ref, watch } from "vue";
import { useStore } from 'vuex';
import { useDraggable, useWindowSize } from '@vueuse/core';
import Bus from '../../utils/bus.js';

const $store = useStore();

const emits = defineEmits(['trigger']);

const num = computed(() => $store.state.designPreprintInfo?.num || 0 );

const { width, height } = useWindowSize(); // 监听 window 尺寸

const floatRef = ref( null );

let dragging = false;
const { x, y, style } = useDraggable( floatRef, {
	initialValue: { x: width.value - 40, y: height.value - 120 },
	onMove: () => {
		dragging = true;
	},
	onEnd: ( position ) => {
		const poi = formatPosition( position )
		floatRef.value.style.left = poi.x + 'px';
		floatRef.value.style.top = poi.y + 'px';
	}
});


// 监听窗口尺寸变化，并执行回调函数
watch([width, height], () => {
	const poi = formatPosition({ x: x.value, y: y.value });
	floatRef.value.style.left = poi.x + 'px';
	floatRef.value.style.top = poi.y + 'px';
});

const formatPosition = ( position ) => {
	const minX = 0;
	const minY = 0;
	const maxX = width.value - floatRef.value.offsetWidth;
	const maxY = height.value - floatRef.value.offsetHeight;
	return {
		x: Math.min( Math.max( position.x, minX ), maxX ),
		y: Math.min( Math.max( position.y, minY ), maxY )
	}
}

const handleClick = () => {
	if ( dragging ){
		dragging = false;
	} else {
		Bus.$emit( 'togglePreprintPanel' )
		emits( 'trigger' );
	}
};

</script>

<style scoped lang="scss">
.float-btn {
	position: fixed;
	z-index: 2002; // 高于header,低于弹框
	.float-wrap {
		cursor: move;
		width: 40px;
		padding: 8px 0;
		border-radius: 6px;
		border: 1px solid #E0E4EA;
		text-align: center;
		background: linear-gradient(180deg, #D5E3FF 0%, #FFFFFF 100%);
		.num {
			font-size: 16px;
			font-weight: 700;
		}
	}
}
</style>
